import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useLockedBody } from 'hooks/useLockedBody';

const AppLoading = (props) => {
  const {
    loading,
    loaderOnPage,
  } = props;

  useLockedBody(loading);

  return (
    loading && (
      <div id="preloader" className={loaderOnPage ? 'is__loader' : ''}>
        <div id="status">
          <div className="spinner-chase">
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
          </div>
        </div>
      </div>
    )
  );
};

AppLoading.propTypes = {
  loading: PropTypes.bool,
  loaderOnPage: PropTypes.bool,
};

AppLoading.defaultProps = {
  loading: false,
  loaderOnPage: false,
};

export default memo(AppLoading);
